import { Card } from "react-bootstrap";

export default function PC() {
    return (
        <div>
            <Card.Title>How to install skeld.net on PC</Card.Title>
            <Card.Text style={{ fontSize: "1em" }}>
                <ol>
                    <li>Make sure you have Among Us installed</li>
                    <li>Run Among Us, then close it</li>
                    <li>
                        Run this command in Command Prompt:
                        <br />
                        curl -o "%APPDATA%/../LocalLow/Innersloth/Among
                        Us/regionInfo.json" "https://api.skeld.net/regionInfo"
                    </li>
                    <li>Launch Among Us</li>
                    <li>Change your region to skeld.net</li>
                </ol>
            </Card.Text>
        </div>
    );
}
